var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlayer = function SvgPlayer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.376 18",
    fill: "#b6bbcc",
    stroke: "#b6bbcc"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191",
    transform: "translate(-1361 -456)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(1361 470)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(1368 456)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M14.747,8.766,12.907,13.5,8.7,12.359,10.278,8.5l.613-2.1,3.506.964Z",
    transform: "translate(1356.419 453.928)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M7.2,11.071l.438-.964A5.1,5.1,0,0,1,9.654,7.829h0a3.157,3.157,0,0,1,2.366-.438l1.49.351a6.976,6.976,0,0,1,1.753.613l4.031,2.191",
    transform: "translate(1356.604 453.814)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x1: 2.804,
    y2: 7.449,
    transform: "translate(1366.258 465.674)",
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    x1: 2.016,
    y2: 4.47,
    transform: "translate(1364.944 464.36)",
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
};
export default SvgPlayer;